import React, { useEffect, useRef, useState } from 'react';
import classes from './ProgressMap.module.css'
import Island from './Island';
import IslandData from './IslandData';
import { ActivityTypeEnum } from '../models/ActivityTypeEnum';
import { useMapStyle } from '../hooks/useMapStyle'
import { useParams } from 'react-router-dom';
import { ProgressMapIslandTypes } from "../models/ProgressMapIslandTypes"
import { useSelector } from 'react-redux';

const ProgressMap = ({ handleShowLessonViewer, topicsList, studyGroupId, aiCourse, markUserPlace, userImg, setMessagePopup }) => {

    const { applictionName } = useParams();
    const { mapImage, mapPathImage } = useSelector((state) => state.application);
    const uiData = useSelector((state) => state.general.uiData);
    const lessonesListType = uiData[applictionName]?.lessonesListType
    const { mapStyle, svgIslandsImgsArr } = useMapStyle();
    const getDefaultType = () => {
        if (topicsList[lessonesListType[0]].length < 9 && topicsList[lessonesListType[2]].length) {
            return lessonesListType[2];
        }
        if (topicsList[lessonesListType[0]].length < 3 && topicsList[lessonesListType[1]].length) {
            return lessonesListType[1];
        }
        return lessonesListType[0];
    }

    const defaultType = getDefaultType();
    const mapRef = useRef()
    const [userPlace, setUserPlace] = useState(false)
    // const [toggelEye, setToggelEye] = useState(true)
    const levelsNum = topicsList[defaultType] ? topicsList[defaultType].length : 0;
    const oneMapHeight = 1740;
    let mheight = levelsNum % (mapStyle[defaultType].length + 1) ? mapStyle[defaultType][(levelsNum % (mapStyle[defaultType].length + 1)) - 1].bottom + mapStyle[defaultType][(levelsNum % (mapStyle[defaultType].length + 1)) - 1].height : 0;
    let more30HeightToMap = levelsNum === (mapStyle[defaultType].length) ? 0 : 30
    let mapheight = Math.floor(levelsNum / (mapStyle[defaultType].length + 1)) * oneMapHeight + mheight + more30HeightToMap;
    let pos = { top: 0, left: 0, x: 0, y: 0 };


    useEffect(() => {
        topicsList && mapRef.current.scrollTo({ left: -600, top: 1198, behavior: "smooth", AnimationTimeline: 700 });
        const topicsListArray = topicsList && Object.values(topicsList);
        if (topicsListArray?.length) {
            let userPlaceTemp;
            let flag = false;
            for (let i = 0; i < topicsListArray.length; i++) {
                for (let j = 0; j < topicsListArray[i]?.length; j++) {
                    userPlaceTemp = topicsListArray[i][j]?.lessons?.find(x => x.assessments?.find(a => ActivityTypeEnum[a.activityType] == ActivityTypeEnum.Final)?.submission?.submissionStatus !== "Completed")
                    if (userPlaceTemp) {
                        setUserPlace(j)
                        flag = true
                        break
                    }
                }
                if (flag)
                    break
            }
        }
    }, [topicsList])

    const mouseDownHandler = function (e) {
        pos = { left: mapRef.current.scrollLeft, top: mapRef.current.scrollTop, x: e.clientX, y: e.clientY };
        mapRef.current.style.cursor = 'grabbing';
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
    };

    const mouseMoveHandler = function (e) {
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;
        mapRef.current.scrollTop = pos.top - dy;
        mapRef.current.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function () {
        mapRef.current.style.cursor = 'grab';
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
    };
    const getsvgIslandsImgsArr = (lessonType, i) => {
        if (lessonType.includes(ProgressMapIslandTypes.contest))
            return svgIslandsImgsArr[ProgressMapIslandTypes.contest][i];
        else if (lessonType.includes(ProgressMapIslandTypes.enrichment))
            return svgIslandsImgsArr[ProgressMapIslandTypes.enrichment][i];
        else
            return svgIslandsImgsArr[ProgressMapIslandTypes.lessons][i];
    };
    return (
        <div className={classes.MapContainer}>
            {/* <div className={`${classes.IconEye} ${toggelEye && classes.Close}`} onClick={() => setToggelEye(!toggelEye)}></div> */}
            <div className={classes.MapWrap} ref={mapRef}>
                <div className={classes.MapT} style={{height: `${mapheight}px`, ...(mapImage && { backgroundImage: `url(${mapImage})` }) }} onMouseDown={mouseDownHandler}>
                    <div className={classes.MapPath} style={mapPathImage && { backgroundImage: `url(${mapPathImage})` }}></div>
                    {lessonesListType.map(lessoneType =>
                        topicsList[lessoneType]?.map((t, i) =>
                            (lessoneType === lessonesListType[0] || i === 0) &&
                            <React.Fragment key={i}>
                                <Island
                                    key={i}
                                    positions={mapStyle[lessoneType][i % mapStyle[lessoneType].length]}
                                    heightSumMapsCreated={Math.floor(i / mapStyle[lessoneType].length) * oneMapHeight}
                                    selectedLevelClass={markUserPlace ? i === userPlace : false ? 'SelectedLevel' : ''}
                                    lastLevelClass={i === levelsNum - 1 ? 'LastLevel' : ''}
                                    svgIslandsImgsArr={getsvgIslandsImgsArr(lessoneType, i)} />

                                <IslandData
                                    index={i}
                                    aiCourse={aiCourse}
                                    positions={mapStyle[lessoneType][i % mapStyle[lessoneType].length]}
                                    tagId={t.tag}
                                    userPlace={markUserPlace ? i === userPlace : false}
                                    endLevel={i === levelsNum - 1}
                                    lessoneType={lessoneType}
                                    heightSumMapsCreated={Math.floor(i / mapStyle[lessoneType].length) * oneMapHeight}
                                    mapRef={mapRef}
                                    mapheight={mapheight}
                                    lessonsList={t.lessons}
                                    studyGroupId={studyGroupId}
                                    handleShowLessonViewer={handleShowLessonViewer}
                                    userImg={userImg}
                                    setMessagePopup={setMessagePopup}
                                />
                                {/* toggelEye={toggelEye} /> */}
                            </React.Fragment>
                        )
                    )}

                </div>
            </div>
        </div>
    )
}
export default ProgressMap;